import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { ProductNamePipe } from 'pipes/product-name.pipe';
import { TranslatePipe } from 'pipes/translate.pipe';
import { FormValidationService } from 'services/form-validation.service';

@Component({
	selector: 'select-product-plan',
	templateUrl: './select-product-plan.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, CustomSelectComponent, TranslatePipe]
})
export class SelectProductPlanComponent {

	private _productPlans?: SelectListItemModel[];
	selectedProductPlanId?: string;
	headline = 'company.product-plans.select-product-plan-header';
	label = 'general.select';
	buttonText = 'general.select';
	required = false;

	@Output() public productPlanSelected = new EventEmitter<string>();

	get productPlans(): SelectListItemModel[] | undefined {
		return this._productPlans;
	}

	@Input()
	set productPlans(plans: ProductPlanModel[] | undefined) {
		this._productPlans = plans?.map(p => new SelectListItemModel(p.id!, this.productName.transform(p)));
	}

	constructor(private readonly productName: ProductNamePipe) { }

	saveChanges() {
		this.productPlanSelected.emit(this.selectedProductPlanId);
	}
}
